<button class="btn-grey-insp" (click)="displayModal()">عرض التفاصيل</button>
